// Swahili Version - TraderRegistrationFormSwahili.js
import React, { useState, useEffect } from 'react';
import { CheckCircle, User, Phone, MapPin, MessageSquare, Calendar, Users, Building2, Send, Plus, Trash2, Package, DollarSign } from 'lucide-react';
import { getborders } from "../../api/border";
import { getProductsAll } from "../../api/products";
import 'bootstrap/dist/css/bootstrap.min.css';

function TraderRegistrationFormSwahili() {
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [borderDatas, setBorderDatas] = useState([]);
    const [productDatas, setProductDatas] = useState([]);
    const [userType, setUserType] = useState('');
    const [products, setProducts] = useState([{ id: 1, productId: '', quantity: '', price: '' }]);
    
    const [formData, setFormData] = useState({
        fullName: '',
        mobileNumber: '',
        age: '',
        gender: '',
        borderName: '',
        officeLocation: '',
        youthEmployed: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleUserTypeChange = (e) => {
        setUserType(e.target.value);
    };

    const handleProductChange = (index, field, value) => {
        const updatedProducts = [...products];
        updatedProducts[index][field] = value;
        setProducts(updatedProducts);
    };

    const addProduct = () => {
        const newProduct = {
            id: products.length + 1,
            productId: '',
            quantity: '',
            price: ''
        };
        setProducts([...products, newProduct]);
    };

    const removeProduct = (index) => {
        if (products.length > 1) {
            const updatedProducts = [...products];
            updatedProducts.splice(index, 1);
            setProducts(updatedProducts);
        }
    };

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();
        setLoading(true);
        
        console.log('Form Submitted:', formData);
        console.log('User Type:', userType);
        console.log('Products:', products);
        
        // Simulating API call
        setTimeout(() => {
            setLoading(false);
            setIsSubmitted(true);
            
            // Reset form after 3 seconds
            setTimeout(() => {
                setIsSubmitted(false);
                setFormData({
                    fullName: '',
                    mobileNumber: '',
                    age: '',
                    gender: '',
                    borderName: '',
                    officeLocation: '',
                    youthEmployed: '',
                });
                setUserType('');
                setProducts([{ id: 1, productId: '', quantity: '', price: '' }]);
            }, 3000);
        }, 1500);
    };

    useEffect(() => {
        setLoading(true);
        
        // Fetch borders
        getborders((result) => {
            if (result.ok === 1) {
                setBorderDatas(result.result);
            }
        });
        
        // Fetch products
        getProductsAll((result) => {
            if (result.ok === 1) {
                setProductDatas(result.result);
            }
            setLoading(false);
        });
    }, []);

    // Hero Section
    const HeroSection = () => (
        <div className="hero-section position-relative overflow-hidden rounded-4 bg-primary mb-5 p-4 p-md-5">
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-20"></div>
            
            {/* Animated background elements */}
            <div className="position-absolute top-0 start-0 w-100 h-100">
                <div className="floating-element element-1 position-absolute bg-primary bg-opacity-20 rounded-circle blur-xl"></div>
                <div className="floating-element element-2 position-absolute bg-purple bg-opacity-20 rounded-circle blur-xl"></div>
                <div className="floating-element element-3 position-absolute bg-info bg-opacity-20 rounded-circle blur-xl"></div>
            </div>
            
            {/* Content */}
            <div className="position-relative z-10 text-center text-white">
                <h1 className="hero-title mb-3 fw-bold">
                    Usajili wa Wafanyabiashara wa Mipakani
                </h1>
                <p className="hero-subtitle mb-4 mx-auto">
                    Unganisha na wanunuzi na wauzaji katika mipaka kwa ajili ya bidhaa za nafaka na mazao ya bustani
                </p>
            </div>
        </div>
    );

    // Success Animation Component
    const SuccessAnimation = () => (
        <div className="modal-backdrop show d-flex align-items-center justify-content-center p-3">
            <div className="success-modal bg-white rounded-4 shadow-lg text-center w-100 max-w-md overflow-hidden">
                {/* Header */}
                <div className="success-header bg-success p-4 p-md-5 text-white">
                    <div className="success-icon-container mx-auto mb-3">
                        <CheckCircle className="success-icon text-white" />
                    </div>
                    <h3 className="success-title fw-bold mb-0">Usajili Umefanikiwa!</h3>
                </div>
                
                {/* Content */}
                <div className="success-content p-4 p-md-5">
                    <h4 className="success-subtitle text-dark mb-3 fw-semibold">Asante kwa Kujisajili</h4>
                    <p className="success-message text-muted mb-4">
                        Usajili wako umepokelewa kwa mafanikio. Timu yetu itakagua maelezo yako na kuwasiliana nawe hivi karibuni.
                    </p>
                    
                    <div className="processing-indicator bg-light rounded-3 p-3">
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="processing-dot me-2"></div>
                            <span className="processing-text text-success fw-medium">Inachakata usajili wako...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    // Loading Component
    const LoadingSpinner = () => (
        <div className="d-flex align-items-center justify-content-center">
            <div className="spinner-dots d-flex me-3">
                <div className="spinner-dot"></div>
                <div className="spinner-dot"></div>
                <div className="spinner-dot"></div>
            </div>
            <span className="loading-text fw-medium">Inatuma Usajili...</span>
        </div>
    );

    return (
        <div className="registration-form-wrapper min-vh-100 bg-light">
            {/* Custom CSS */}
            <style jsx>{`
                .registration-form-wrapper {
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);
                }

                .hero-section {
                    background: linear-gradient(135deg, #2c3e50 0%, #3498db 50%, #9b59b6 100%) !important;
                }

                .hero-title {
                    font-size: 2.5rem;
                    letter-spacing: -0.5px;
                }

                .hero-subtitle {
                    font-size: 1.1rem;
                    opacity: 0.9;
                    max-width: 600px;
                }

                .form-container {
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.2);
                    box-shadow: 0 20px 40px rgba(0,0,0,0.1);
                }

                .form-section {
                    margin-bottom: 2rem;
                }

                .form-field {
                    transition: all 0.3s ease;
                    border: 2px solid transparent;
                    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
                }

                .form-field:hover {
                    border-color: #007bff;
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                }

                .form-field:focus-within {
                    border-color: #007bff;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0,123,255,0.15);
                }

                .field-icon {
                    transition: transform 0.3s ease;
                }

                .form-field:focus-within .field-icon {
                    transform: scale(1.1) rotate(5deg);
                }

                .submit-btn {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border: none;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .submit-btn:hover:not(:disabled) {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
                }

                .submit-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .floating-element {
                    animation: float 6s ease-in-out infinite;
                }

                .element-1 {
                    width: 80px;
                    height: 80px;
                    top: 10%;
                    left: 10%;
                    animation-delay: 0s;
                }

                .element-2 {
                    width: 120px;
                    height: 120px;
                    top: 20%;
                    right: 15%;
                    animation-delay: 2s;
                }

                .element-3 {
                    width: 100px;
                    height: 100px;
                    bottom: 15%;
                    left: 20%;
                    animation-delay: 4s;
                }

                .success-icon {
                    width: 60px;
                    height: 60px;
                }

                .success-icon-container {
                    width: 80px;
                    height: 80px;
                    background: rgba(255,255,255,0.2);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    animation: bounce 2s infinite;
                }

                .processing-dot {
                    width: 8px;
                    height: 8px;
                    background: #28a745;
                    border-radius: 50%;
                    animation: pulse 1.5s infinite;
                }

                .spinner-dot {
                    width: 12px;
                    height: 12px;
                    background: white;
                    border-radius: 50%;
                    animation: bounce 1.4s infinite;
                }

                .spinner-dot:nth-child(2) {
                    animation-delay: 0.2s;
                }

                .spinner-dot:nth-child(3) {
                    animation-delay: 0.4s;
                }

                .modal-backdrop {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0,0.8);
                    backdrop-filter: blur(5px);
                    z-index: 1050;
                }

                .user-type-card {
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border: 2px solid transparent;
                }

                .user-type-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
                }

                .user-type-card.selected {
                    border-color: #007bff;
                    background-color: rgba(0,123,255,0.1);
                }

                .product-table {
                    border-radius: 10px;
                    overflow: hidden;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                }

                .product-table th {
                    background-color: #f8f9fa;
                    font-weight: 600;
                }

                .add-product-btn {
                    background-color: #28a745;
                    border: none;
                    transition: all 0.3s ease;
                }

                .add-product-btn:hover {
                    background-color: #218838;
                    transform: translateY(-2px);
                }

                .remove-product-btn {
                    background-color: #dc3545;
                    border: none;
                    transition: all 0.3s ease;
                }

                .remove-product-btn:hover {
                    background-color: #c82333;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-20px) rotate(5deg); }
                }

                @keyframes bounce {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }

                @keyframes pulse {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.5; transform: scale(0.8); }
                }

                .max-w-md {
                    max-width: 400px;
                }

                /* Mobile Styles */
                @media (max-width: 576px) {
                    .hero-title {
                        font-size: 1.75rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 0.95rem;
                    }
                    
                    .form-container {
                        padding: 1.5rem !important;
                    }
                    
                    .form-section {
                        margin-bottom: 1.5rem;
                    }
                    
                    .section-title {
                        font-size: 1.25rem;
                    }
                    
                    .form-field {
                        padding: 0.75rem !important;
                    }
                    
                    .form-label {
                        font-size: 0.9rem;
                    }
                    
                    .form-control, .form-select {
                        font-size: 0.9rem;
                        padding: 0.5rem 0.75rem;
                    }
                    
                    .user-type-card .card-body {
                        padding: 1.5rem 1rem;
                    }
                    
                    .user-type-card .card-title {
                        font-size: 1.1rem;
                    }
                    
                    .user-type-card .card-text {
                        font-size: 0.85rem;
                    }
                    
                    .product-table {
                        font-size: 0.85rem;
                    }
                    
                    .product-table th, .product-table td {
                        padding: 0.5rem;
                    }
                    
                    .submit-btn {
                        padding: 0.75rem;
                        font-size: 1rem;
                    }
                    
                    .success-modal {
                        margin: 0 1rem;
                    }
                    
                    .success-title {
                        font-size: 1.25rem;
                    }
                    
                    .success-subtitle {
                        font-size: 1.1rem;
                    }
                    
                    .success-message {
                        font-size: 0.9rem;
                    }
                }

                /* Tablet Styles */
                @media (min-width: 577px) and (max-width: 991px) {
                    .hero-title {
                        font-size: 2.25rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 1.05rem;
                    }
                    
                    .form-container {
                        padding: 2rem !important;
                    }
                    
                    .section-title {
                        font-size: 1.4rem;
                    }
                    
                    .form-field {
                        padding: 1rem !important;
                    }
                    
                    .user-type-card .card-body {
                        padding: 2rem;
                    }
                    
                    .product-table {
                        font-size: 0.9rem;
                    }
                    
                    .product-table th, .product-table td {
                        padding: 0.75rem;
                    }
                }

                /* Desktop Styles */
                @media (min-width: 992px) {
                    .hero-title {
                        font-size: 2.5rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 1.1rem;
                    }
                    
                    .form-container {
                        padding: 2.5rem !important;
                    }
                    
                    .section-title {
                        font-size: 1.5rem;
                    }
                    
                    .form-field {
                        padding: 1.25rem !important;
                    }
                    
                    .user-type-card .card-body {
                        padding: 2.5rem;
                    }
                    
                    .product-table {
                        font-size: 1rem;
                    }
                    
                    .product-table th, .product-table td {
                        padding: 1rem;
                    }
                }

                /* Large Desktop Styles */
                @media (min-width: 1200px) {
                    .hero-title {
                        font-size: 2.75rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 1.15rem;
                    }
                    
                    .form-container {
                        padding: 3rem !important;
                    }
                    
                    .section-title {
                        font-size: 1.6rem;
                    }
                    
                    .form-field {
                        padding: 1.5rem !important;
                    }
                    
                    .user-type-card .card-body {
                        padding: 3rem;
                    }
                }

                /* Extra Large Desktop Styles */
                @media (min-width: 1400px) {
                    .container {
                        max-width: 1140px;
                    }
                }
            `}</style>

            <div className="container py-4">
                <HeroSection />
                
                <div className="form-container bg-white bg-opacity-90 rounded-4 shadow-lg p-4 p-md-5">
                    <form onSubmit={handleSubmit}>
                        <div className="row g-4">
                            {/* User Type Selection Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="section-icon bg-primary rounded-2 d-flex align-items-center justify-content-center me-3">
                                        <User className="text-white" />
                                    </div>
                                    <h2 className="section-title text-dark mb-0 fw-bold">Aina ya Usajili</h2>
                                </div>
                                
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <div 
                                            className={`user-type-card card h-100 ${userType === 'seller' ? 'selected' : ''}`}
                                            onClick={() => setUserType('seller')}
                                        >
                                            <div className="card-body text-center p-4">
                                                <Package className="text-primary mb-3" size={48} />
                                                <h5 className="card-title">Jisajili Kama Mauzaji</h5>
                                                <p className="card-text text-muted">
                                                    Mimi ni mfanyabiashara wa mipakani wa nafaka/mazao ya bustani ninayetafuta wanunuzi
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div 
                                            className={`user-type-card card h-100 ${userType === 'buyer' ? 'selected' : ''}`}
                                            onClick={() => setUserType('buyer')}
                                        >
                                            <div className="card-body text-center p-4">
                                                <DollarSign className="text-success mb-3" size={48} />
                                                <h5 className="card-title">Jisajili Kama Mnunuzi</h5>
                                                <p className="card-text text-muted">
                                                    Ninavutiwa kununua nafaka/mazao ya bustani kutoka kwa wafanyabiashara wa mipakani
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Personal Information Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="section-icon bg-info rounded-2 d-flex align-items-center justify-content-center me-3">
                                        <User className="text-white" />
                                    </div>
                                    <h2 className="section-title text-dark mb-0 fw-bold">Maelezo ya Kibinafsi</h2>
                                </div>
                                
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <User className="field-icon text-primary me-2" />
                                                Jina Kamili
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="fullName"
                                                placeholder="Weka jina lako kamili"
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Phone className="field-icon text-success me-2" />
                                                Namba ya Simu (WhatsApp)
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <input
                                                type="tel"
                                                name="mobileNumber"
                                                placeholder="+255 XXX XXX XXX"
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.mobileNumber}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Calendar className="field-icon text-purple me-2" />
                                                Kundi la Umri
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <select
                                                name="age"
                                                className="form-select border-0 bg-transparent px-2 py-2"
                                                value={formData.age}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Chagua kundi lako la umri</option>
                                                <option value="below_35">Chini ya miaka 35</option>
                                                <option value="above_35">Zaidi ya miaka 35</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Users className="field-icon text-pink me-2" />
                                                Jinsia
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <select
                                                name="gender"
                                                className="form-select border-0 bg-transparent px-2 py-2"
                                                value={formData.gender}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Chagua jinsia</option>
                                                <option value="male">Mwanaume</option>
                                                <option value="female">Mwanamke</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Products Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap">
                                    <div className="d-flex align-items-center mb-2 mb-md-0">
                                        <div className="section-icon bg-warning rounded-2 d-flex align-items-center justify-content-center me-3">
                                            <Package className="text-white" />
                                        </div>
                                        <h2 className="section-title text-dark mb-0 fw-bold">Maelezo ya Bidhaa</h2>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn add-product-btn text-white d-flex align-items-center"
                                        onClick={addProduct}
                                    >
                                        <Plus size={18} className="me-1" />
                                        Ongeza Bidhaa
                                    </button>
                                </div>
                                
                                <div className="product-table table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Jina la Bidhaa</th>
                                                <th>
                                                    {userType === 'seller' ? 'Kiasi cha Uuzaji (kwa mwezi)' : 'Kiasi kinachohitajika'}
                                                </th>
                                                <th>
                                                    {userType === 'seller' ? 'Bei ya Uuzaji kwa kipimo' : 'Bei ya Kununua kwa kipimo'}
                                                </th>
                                                <th>Vitendo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {products.map((product, index) => (
                                                <tr key={product.id}>
                                                    <td>
                                                        <select
                                                            className="form-select border-0 bg-transparent"
                                                            value={product.productId}
                                                            onChange={(e) => handleProductChange(index, 'productId', e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Chagua bidhaa</option>
                                                            {productDatas.map((item) => (
                                                                <option key={item._id} value={item._id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control border-0 bg-transparent"
                                                            placeholder="mf: 100 kg"
                                                            value={product.quantity}
                                                            onChange={(e) => handleProductChange(index, 'quantity', e.target.value)}
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control border-0 bg-transparent"
                                                            placeholder="mf: $2.50 kwa kg"
                                                            value={product.price}
                                                            onChange={(e) => handleProductChange(index, 'price', e.target.value)}
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn remove-product-btn text-white"
                                                            onClick={() => removeProduct(index)}
                                                            disabled={products.length === 1}
                                                        >
                                                            <Trash2 size={16} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Business Information Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="section-icon bg-success rounded-2 d-flex align-items-center justify-content-center me-3">
                                        <Building2 className="text-white" />
                                    </div>
                                    <h2 className="section-title text-dark mb-0 fw-bold">Maelezo ya Biashara</h2>
                                </div>
                                
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Users className="field-icon text-info me-2" />
                                                Idadi ya Vijana Waliopata Ajira
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                name="youthEmployed"
                                                placeholder="Weka idadi ya vijana waliopata ajira"
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.youthEmployed}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <MapPin className="field-icon text-danger me-2" />
                                                Jina la Mpaka
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <select
                                                name="borderName"
                                                className="form-select border-0 bg-transparent px-2 py-2"
                                                value={formData.borderName}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Chagua kituo cha mpaka</option>
                                                {borderDatas.map((item, index) => (
                                                    <option key={index} value={item.name}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Building2 className="field-icon text-warning me-2" />
                                                Maelezo ya Mahali pa Ofisi
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <textarea
                                                name="officeLocation"
                                                rows="3"
                                                placeholder="Toa maelezo ya kina kuhusu mahali pa ofisi yako"
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.officeLocation}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="col-12">
                                <button
                                    type="submit"
                                    disabled={loading || !userType}
                                    className="submit-btn w-100 text-white fw-bold py-3 rounded-3"
                                >
                                    {loading ? (
                                        <LoadingSpinner />
                                    ) : (
                                        <span className="d-flex align-items-center justify-content-center">
                                            <Send className="me-2" />
                                            Tuma Usajili
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Success Modal */}
            {isSubmitted && <SuccessAnimation />}
        </div>
    );
}

export default TraderRegistrationFormSwahili;